export default (traits, { rhythm }) => ({
  label: {
    marginBottom: rhythm(0.25)
  },

  logo: {
    maxHeight: rhythm(1.5)
  }
})



// WEBPACK FOOTER //
// ./components/container/Footer/PoweredBy/styles.js